import React, { createContext, useContext, useEffect, useState } from "react";
import { AuthContext } from "./AuthContext";
import { Col, Modal, Row, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { currentTeamId } from "../Utils/utils";
import BuyMoreAppsModal from "../Components/Pages/Settings/AccountBilling/BuyMoreAppsModal";
import { ToastContext } from "./ToastContext";
import "../Components/Pages/Settings/AccountBilling/style.css";
import { getSubscribedPlanAppsHelper } from "../Components/Pages/Settings/AccountBilling/PlansHelper";
import { Link } from "react-router-dom";

export const LimitationContext = createContext();

export const LimitationProvider = ({ children }) => {
  const { t: locale } = useTranslation();
  const [limitations, setLimitations] = useState([]);
  const [show, setShow] = useState(false);
  const [apps, setApps] = useState([]);
  const [mode, setMode] = useState("warning"); //"warning" || "purchase"
  const [showBuyAppsModal, setShowBuyAppsModal] = useState(false);
  const [pName, setPName] = useState(null);
  const [subscribedPlan, setSubscribedPlan] = useState(null);
  const { userData } = useContext(AuthContext);
  const { addToast } = useContext(ToastContext);

  const handleClose = () => {
    setShow(false);
    setMode("warning");
  };

  const normalizeAppName = (value) =>
    typeof value === "string" ? value.trim().toLowerCase() : "";

  const fetchLimitation = (lt) => {
    const decodedLt = window.atob(lt);
    let ltData = [];
    if (decodedLt !== `[]` && decodedLt !== `""`) {
      ltData = JSON.parse(JSON.parse(decodedLt));
    }
    if (Array.isArray(ltData.plan_apps)) {
      const normalizedApps = [
        ...new Set(ltData.plan_apps.map(normalizeAppName).filter(Boolean)),
      ];
      setLimitations(normalizedApps);
    }
  };

  const checkPermission = (name) => {
    const normalizedName = normalizeAppName(name);
    // console.log("Available Limitations:", limitations, "Check For:", name);
    // setShow(true);
    // return true;
    if (!limitations.includes(normalizedName)) {
      setPName(normalizedName);
      setShow(true);
      return true;
    } else {
      setPName(null);
      return false;
    }
  };

  const showAppPurchasePopup = () => {
    setShow(true);
  };

  useEffect(() => {
    if (subscribedPlan?.plan_name === "Custom Plan") {
      getSubscribedPlanAppsHelper({
        team_id: currentTeamId,
        plan_subscription_id: subscribedPlan.id,
      })
        .then((data) => {
          setApps(data.data);
        })
        .catch((err) => {
          const errorMessage = err.message || "Error fetching subscribed apps";
          addToast(
            {
              id: "fetchAppsError",
              message: errorMessage,
              title: "Error",
            },
            "danger",
            5000
          );
        });
    }
  }, [subscribedPlan]);

  useEffect(() => {
    if (userData?.authData?.currentTeam?.lt) {
      const { name, id } = userData?.authData?.subscription?.plan || {
        name: null,
        id: null,
      };
      setSubscribedPlan({
        ...userData?.authData.subscription,
        plan_name: name || "Unknown",
        plan_id: id,
      });
      fetchLimitation(userData?.authData?.currentTeam.lt);
    }
  }, [userData]);

  const staticMessage = (
    <Row>
      {subscribedPlan?.plan?.is_custom ? (
        <Col className="my-4 text-center">
          <h3 className="border py-3">
            Access to this app is not included in your current subscription
            plan. To use this app, please purchase it or upgrade your plan.
          </h3>
          <div className="my-4">
            <Link
              className="btn btn-primary btn-primary btn-sm"
              to="/settings/accounts-and-billing"
            >
              Purchase App
            </Link>
          </div>
        </Col>
      ) : (
        <Col className="my-4 text-center">
          <h3 className="border py-3">
            {locale(
              "Access to this feature is not included in your current subscription plan. To use this feature, please upgrade your plan."
            )}
          </h3>
          <div className="my-4">
            <Link
              className="btn btn-primary btn-primary btn-sm"
              to="/settings/accounts-and-billing"
              onClick={() => {}}
            >
              Upgrade Plan
            </Link>
          </div>
        </Col>
      )}
    </Row>
  );

  const value = {
    subscribedPlan,
    limitations,
    checkPermission,
    showAppPurchasePopup,
    staticMessage,
  };

  return (
    <LimitationContext.Provider value={value}>
      {children}
      <Modal
        className={`common ${mode === "warning" ? "modalLg" : "modalDxl"}`}
        show={show}
        backdrop="static"
        keyboard={false}
        centered={false}
        onHide={() => handleClose(false)}
      >
        <Modal.Header
          closeButton
          closeVariant={"white"}
          className={"modal-head"}
        >
          <Modal.Title className={"text-dark secondary-font text-uppercase"}>
            {subscribedPlan?.plan?.is_custom
              ? locale("Purchase App")
              : locale("Upgrade Plan")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {subscribedPlan?.plan?.is_custom ? (
              <Col className="my-4 text-center">
                <h3 className="border py-3">
                  Access to this app is not included in your current
                  subscription plan. To use this app, please purchase it or
                  upgrade your plan.
                </h3>
                <div className="my-4">
                  <Button
                    onClick={() => {
                      setShowBuyAppsModal(true);
                      handleClose(false);
                    }}
                  >
                    Purchase App
                  </Button>
                </div>
              </Col>
            ) : (
              <Col className="my-4 text-center">
                <h3 className="border py-3">
                  {locale(
                    "Access to this feature is not included in your current subscription plan. To use this feature, please upgrade your plan."
                  )}
                </h3>
                <div className="my-4">
                  <Link
                    className="btn btn-primary btn-primary btn-sm"
                    to="/settings/accounts-and-billing"
                    onClick={() => {
                      handleClose(false);
                    }}
                  >
                    Upgrade Plan
                  </Link>
                </div>
              </Col>
            )}
          </Row>
        </Modal.Body>
      </Modal>
      {/* Render the BuyMoreAppsModal */}

      <BuyMoreAppsModal
        show={showBuyAppsModal}
        onHide={() => setShowBuyAppsModal(false)}
        boughtApps={apps}
        teamId={currentTeamId}
        handleAlertMessage={(type, message = {}) => {
          addToast(
            {
              id: "buyMoreAppsToast",
              message,
              title: type === "error" ? "Error" : "Success",
            },
            type === "error" ? "danger" : "success",
            5000
          );
        }}
        pName={pName}
      />
    </LimitationContext.Provider>
  );
};
